export default __webpack_public_path__ + "static/media/image-popup-community-letalk.5b5e4250.png";